import universal from 'react-universal-component';

export default universal(() => import('./Layout'));



// WEBPACK FOOTER //
// ./src/app/Layout/index.js